<script lang="ts">
    import { Route, Router } from 'yrv'
    import Ztab from '../_common/z/ztab.svelte'
    import Content from '../_common/content.svelte'
    import ContentFormsConfig from '../account/customer-service-models/customer-service-models.svelte'
    import CustomerServiceEntries from './customer-service-entries.svelte'
    import CustomerServiceFormPrint from './customer-service-form-print.svelte'

    let tabs = [
        {
            title: 'Atendimento',
            url: '/customer-service/entries',
        },
    ]
    if (!window.store.token.permissions.customerService.configs.write) {
        tabs.splice(1, 1)
    }
</script>

<div class="root-content">
    <Ztab class="h-space" {tabs} />
    <Content footer={true}>
        <Router>
            <Route path="/entries">
                <CustomerServiceEntries></CustomerServiceEntries>
            </Route>
            <Route path="/configs">
                <div class="p-3 text-center">
                    Este recurso mudou para a aba <b>Ferramentas</b>
                </div>
            </Route>
            <Route path="/print">
                <CustomerServiceFormPrint></CustomerServiceFormPrint>
            </Route>
        </Router>
    </Content>
</div>
